import VSelectCardUpdateType from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardUpdateType', VSelectCardUpdateType),
};
